import { Fragment } from "react"
import { useTranslation } from "react-i18next"
import { CommandGroup } from "@/components/ui/command"
import { SearchItem } from "@/components/ui/search"
import { cn } from "@/lib/utils"
import { deMedicationFragmentInline$data } from "@/modules/patients/detail/medication/de/services/__generated__/deMedicationFragmentInline.graphql"
import { isFreeTextMedicationType } from "@/modules/patients/detail/medication/lib/is-free-text-medication-type"
import { RecommendedMedicationItem } from "@/modules/patients/detail/recommended-medications/components/recommended-medication-item"

interface RecommendedMedicationOptionsProps {
  inputValue: string
  renderOptions?: { title: string; options: deMedicationFragmentInline$data[] }[]
  hasSearchResults?: boolean
  handleSelectOption: (options: deMedicationFragmentInline$data) => void
}
export const RecommendedMedicationOptions = (props: RecommendedMedicationOptionsProps) => {
  const { hasSearchResults, inputValue, renderOptions, handleSelectOption } = props

  const { t } = useTranslation()

  return (
    renderOptions && (
      <>
        {renderOptions.map((group, index) => {
          if (group.options.length === 0) return null

          const title = t(group.title)
          return (
            <Fragment key={title}>
              {index !== 0 && renderOptions[index - 1].options.length > 0 && <div className="border-t" />}
              <CommandGroup data-testid={`${title.toLowerCase()}-section`} heading={title} className="px-2">
                {group.options.map((option) => (
                  <SearchItem
                    key={option.id}
                    className={cn(hasSearchResults ? "rounded-md" : "p-0")}
                    value={option.id}
                    onSelect={() => handleSelectOption(option)}>
                    <RecommendedMedicationItem
                      title={option.name}
                      text={option.name}
                      searchText={hasSearchResults ? inputValue : ""}
                      className={cn("truncate", isFreeTextMedicationType(option.type) && "pr-1 italic")}
                    />
                  </SearchItem>
                ))}
              </CommandGroup>
            </Fragment>
          )
        })}
      </>
    )
  )
}
